import * as React from 'react';
export const IcCup = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18 4.28V3a1 1 0 00-1-1H7a1 1 0 00-1 1v1.28a4.46 4.46 0 00.28 8.52A6 6 0 0011 16.91V20H9a1 1 0 000 2h6a1 1 0 000-2h-2v-3.09a6 6 0 004.72-4.11A4.46 4.46 0 0018 4.28zM6 10.49a2.47 2.47 0 010-4v4zm7.8-2l-.57.51.14.79a.49.49 0 01-.5.58.46.46 0 01-.23-.06l-.7-.37-.71.37a.49.49 0 01-.52 0 .51.51 0 01-.2-.49l.13-.82-.57-.55A.5.5 0 0110 8a.47.47 0 01.4-.34l.79-.12.35-.71a.52.52 0 01.89 0l.36.71.78.12a.5.5 0 01.41.34.49.49 0 01-.18.46v.03zm4.2 2v-4a2.47 2.47 0 010 4z'
      fill='currentColor'
    />
  </svg>
);
